import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import environment from "web/script/modules/environment";
export var Hotjar =
/*#__PURE__*/
function () {
  function Hotjar() {
    _classCallCheck(this, Hotjar);

    this.cookieType = "analytics";
    this.hotjar = environment.get("hotjar");
  }

  _createClass(Hotjar, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.hotjar) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Promise.resolve());

              case 2:
                return _context.abrupt("return", new Promise(function (resolve) {
                  (function (h, o, t, j, i) {
                    h.hj = h.hj || function () {
                      // eslint-disable-next-line prefer-rest-params
                      (h.hj.q = h.hj.q || []).push(arguments);
                    };

                    h._hjSettings = {
                      hjid: i.id,
                      hjsv: 6
                    };
                    var a = o.getElementsByTagName("head")[0];
                    var r = o.createElement("script");
                    r.async = Boolean(1);
                    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
                    r.addEventListener("load", function () {
                      resolve();
                    });
                    a.appendChild(r);
                  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=", _this.hotjar);
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }]);

  return Hotjar;
}();